import { Fragment, memo, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Route, Routes, useMatch, useNavigate, useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ChangePassword, CreatePassword, loginActions, LoginPage, ResetPassword } from 'primary-components';

import globalConsts from 'resources/constants/globalConsts';
import properties from 'resources/constants/properties.json';
import { routing } from 'routing';

import ErrorBoundaryLocal from '../ErrorBoundary';

const NonAuthedRouting = ({ isMcpLogin = false, tokenExist = false, children = undefined }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const matchActivateTemplate = useMatch(`/${routing.activate.name}/:token/:templateName`);
  const matchActivate = useMatch(`/${routing.activate.name}/:token`);
  const matchReset = useMatch(`/${routing.changePassword.name}/:token`);
  const [searchParams] = useSearchParams()
  const withWelcomeEmail = useMemo(() => searchParams.get("withWelcomeEmail") === "true", [searchParams])

  useEffect(() => {
    dispatch(loginActions.loginAllTabs())
  }, [dispatch])

  return (
    <Routes>
      <Route 
          element={
            <ResetPassword
                logoWithTextUrl={properties.logoWithTextUrl}
                logoWithTextUrlDarkMode={properties.logoWithTextUrlDarkMode}
                siteKey={properties.siteKey}
            />
          }
          ErrorBoundary={ErrorBoundaryLocal}
          exact
          key="ResetPassword"
          path={"/" + routing.resetPassword.name}
      />
      <Route 
          element={(
            <CreatePassword
                {...(matchActivate?.params || {})}
                logoWithTextUrl={properties.logoWithTextUrl}
                logoWithTextUrlDarkMode={properties.logoWithTextUrlDarkMode}
                navigate={navigate}
                policyUrl={properties.baseUrl.policyUrl}
                supportEmail={properties.supportEmail}
                withWelcomeEmail={withWelcomeEmail}
            />
          )}
          ErrorBoundary={ErrorBoundaryLocal}
          exact
          key="CreatePassword"
          path={"/" + routing.activate.name + "/:token"}
      />
      <Route 
          element={(
            <CreatePassword
                {...(matchActivateTemplate?.params || {})}
                logoWithTextUrl={properties.logoWithTextUrl}
                logoWithTextUrlDarkMode={properties.logoWithTextUrlDarkMode}
                navigate={navigate}
                policyUrl={properties.baseUrl.policyUrl}
                supportEmail={properties.supportEmail}
                withWelcomeEmail={withWelcomeEmail}
            />
          )}
          ErrorBoundary={ErrorBoundaryLocal}
          exact
          key="CreatePassword"
          path={"/" + routing.activate.name + "/:token/:templateName"}
      />
      <Route 
          element={
            <ChangePassword
                {...(matchReset?.params || {})}
                logoWithTextUrl={properties.logoWithTextUrl}
                logoWithTextUrlDarkMode={properties.logoWithTextUrlDarkMode}
                navigate={navigate}
            />
          }
          ErrorBoundary={ErrorBoundaryLocal}
          exact
          key="ChangePassword"
          path={"/" + routing.changePassword.name + "/:token"}
      />
      <Route
          element={!tokenExist ? (
            <LoginPage
                {...properties}
                isMcpLogin={isMcpLogin}
                isXpansiv={properties.isXpansiv === "true" || properties.isXpansiv === true}
                navigate={navigate}
                shouldAutoRedirect={globalConsts.IS_SSO_ONLY_STAGE}
            />
          ) : <Fragment/>}
          ErrorBoundary={ErrorBoundaryLocal}
          path="*"
      />
      {children}
    </Routes>
  )
}

NonAuthedRouting.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Route),
    PropTypes.arrayOf(
      PropTypes.instanceOf(Route)
    )
  ]),
  isMcpLogin: PropTypes.bool,
  tokenExist: PropTypes.bool,
}

export default memo(NonAuthedRouting);
